import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/plugins/i18n'


import Main from '@/pages/Main'
import ClinicMain from '@/pages/ClinicMain'
import ClinicServiceList from '@/pages/ClinicServiceList'
import ClinicServiceDetail from '@/pages/ClinicServiceDetail'
import Social from '@/pages/Social'
import Faqs from '@/pages/Faqs'
import Blog from '@/pages/Blog'
import BlogPost from '@/pages/BlogPost'
import AtHome from '@/pages/AtHome'
import RequestAppt from '@/pages/RequestAppt'

import OnlineAssessmentRoutine from '@/pages/OnlineAssessmentRoutine'
import OnlineAssessmentResults from '@/pages/OnlineAssessmentResults'

import OnlineExperienceFacial from '@/pages/OnlineExperienceFacial'
import OnlineLanding from '@/pages/OnlineLanding'

import FeaturedListing from '@/pages/FeaturedListing'
import FeaturedDetail from '@/pages/FeaturedDetail'


import WeightLoss from '@/pages/WeightLoss'
import ShareRoutine from '@/pages/ShareRoutine'
import termsprivacy from '@/pages/TermsPrivacy'
import Forms from '@/pages/Forms'
import notfound from '@/pages/NotFound'

import Main3 from '@/pages/Main3'
import GiftCardDetail from '@/pages/GiftCardDetail'


Vue.use(Router)

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main3
    },

    {
      path: '/onlineconsultation/',
      name: 'onlineconsultation',
      component: OnlineLanding
    },
    {
      path: '/clinic',
      name: 'clinic',
      component: ClinicMain,
    },
    {
      path: '/clinic/services/',
      name: 'services',
      component: ClinicServiceList,
    },
    // {
    //   path: '/clinic/weightloss/',
    //   name: 'weightloss',
    //   component: WeightLoss,
    // },
    {
      path: '/clinic/services/:service',
      name: 'servicedetail',
      component: ClinicServiceDetail,
    },
    {
      path: '/clinic/forms/:name',
      name: 'FormDetail',
      component: Forms,
    },
    // {
    //   path: '/social',
    //   name: 'social',
    //   component: Social
    // },
    {
      path: '/faqs',
      name: 'faqs',
      component: Faqs
    },
    {
      path: '/featured',
      name: 'featured',
      component: FeaturedListing
    },
    {
      path: '/featured/:slug',
      name: 'featured-detail',
      component: FeaturedDetail
    },
    {
      path: '/giftc/:slug',
      name: 'giftc-detail',
      component: GiftCardDetail
    },
    // {
    //   path: '/blog',
    //   name: 'blog',
    //   component: Blog
    // },
    // {
    //   path: '/blog/:slug',
    //   name: 'blog-post',
    //   component: BlogPost
    // },
    {
      path: '/contact',
      name: 'contact',
      component: RequestAppt
    },
    // {
    //   path: '/at-home',
    //   name: 'athome',
    //   component: AtHome
    // },
    {
      path: '/online/experience/facial',
      name: 'onlineexperiencefacial',
      component: OnlineExperienceFacial
    },
    {
      path: '/online/assessment/routine',
      name: 'OnlineAssessmentRoutine',
      component: OnlineAssessmentRoutine
    },
    {
      path: '/online/assessment/routine/results',
      name: 'OnlineAssessmentResults',
      component: OnlineAssessmentResults,
      // props: true
    },
    {
      path: '/appointment',
      name: 'appointment',
      component: RequestAppt
    },
    {
      path: '/shareroutine',
      name: 'shareroutine',
      component: ShareRoutine
    },
    {
      path: '/terms-privacy',
      name: 'termsprivacy',
      component: termsprivacy
    },
    {
      path: '*',
      name: '404',
      component: notfound
    }
  ],
})

// router.afterEach((to, from) => {
//   const data = {
//     'session': '',
//     'lang': i18n.locale,
//     'from': from.path,
//     'to': to.path,
//     'datetime': new Date()
//   }
//   console.log(data)
// })


export default router


// WEBPACK FOOTER //
// ./src/router/index.js